import React from "react";
import { NavLink } from "react-router-dom";
import Layout from "../../components/Layout";
import TwoColumns from "../../components/TwoColumns";
import * as S from "./styles";

const Row = ({ title, link, pdf }) => {
  let cleanTitle = title.replace(/^<p>(.*)<\/p>$/, "$1");
  if (link || pdf) {
    let to = link || pdf;
    let content = (
      <a
        href={to}
        target="_blank"
        dangerouslySetInnerHTML={{ __html: cleanTitle }}
        key={"link"}
      />
    );
    return <li>{content}</li>;
  }
  return <li dangerouslySetInnerHTML={{ __html: cleanTitle }} key={"link"} />;
};

const Writings = ({ items }) => {
  return (
    <Layout>
      <TwoColumns>
        <S.SubNav>
          <div>
            <NavLink to="/writings" exact>
              Articles
            </NavLink>
          </div>
          <div>
            <NavLink to="/writings/books-and-catalogues">
              Books & Catalogues
            </NavLink>
          </div>
          <div>
            <NavLink to="/writings/interviews-and-writings">
              Interviews & Writings
            </NavLink>
          </div>
        </S.SubNav>
        <S.List>
          {items.map((o, i) => {
            return <Row {...o} key={i} />;
          })}
        </S.List>
      </TwoColumns>
    </Layout>
  );
};

export default Writings;
